// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"248":"4dbb9151","523":"1ba155aa","958":"190779a5"}[chunkId] + ".chunk.css";
};